<template>
  <BaseInput
    :errors="props.errors"
    :id="props.id"
    :label="props.label"
    :modelValue="props.modelValue"
    :placeholder="props.placeholder"
    :toolTipLabel="props.toolTipLabel"
    :type="state.visible ? 'text' : 'password'"
    :disabled="currentUser"
    @update:modelValue="(value: string) => $emit('update:modelValue', value)"
  >
    <template v-slot:suffix>
      <EyeIcon v-if="!state.visible" class="suffix-icon" @click="state.visible = true" />
      <EyeSlashIcon v-if="state.visible" class="suffix-icon" @click="state.visible = false" />
    </template>
  </BaseInput>
</template>

<script setup lang="ts">
import BaseInput from "@/components/FormInputs/BaseInput.vue";
import { ErrorObject } from "@vuelidate/core";
import { computed, reactive } from "vue";
import { EyeIcon, EyeSlashIcon } from "@heroicons/vue/24/solid";
import { getCurrentUser } from "@/store/mainInterface";

defineEmits<{
  'update:modelValue': [value: string];
}>();

const props = defineProps<{
  id: string;
  modelValue: string;
  errors?: ErrorObject[];
  label?: string;
  placeholder?: string;
  toolTipLabel?: string;
}>();

const state = reactive<{
  visible: boolean;
}>({
  visible: false,
});

const currentUser = computed(() => getCurrentUser()?.role === 'admin');
</script>

<style scoped lang="scss">
.suffix-icon {
  @apply text-gray-500;

  width: 1.5rem;
  height: 1.5rem;
  cursor: pointer;
}
</style>
